import React from "react"
import { Icon, Modal } from "@ncs/web-legos"
import { css } from "@emotion/react"
import { useCustomerPaymentMethods } from "@ncs/ncs-api/portal-apps"

interface BankAccountAddedProps {
	isOpen: boolean
	onClose: () => void
}

export const BankAccountAdded: React.FC<BankAccountAddedProps> = ({ isOpen, onClose }) => {
	const [customerPaymentMethods] = useCustomerPaymentMethods()
	const bankAccounts = customerPaymentMethods?.bankAccounts ?? []
	const lastBankAccount = bankAccounts[bankAccounts.length - 1] ?? null

	return (
		<Modal
			showCloseButton={false}
			isOpen={isOpen}
			onClose={onClose}
			rightButtons={{
				buttonText: "CLOSE",
				variant: "clear",
				onClick: onClose,
			}}
		>
			<div css={container}>
				<span>
					<Icon icon="check" fontSize={2} color="white" />
				</span>
				<h3>Bank Account Added!</h3>
				<p>
					Your account ending in ...{lastBankAccount?.accountNumberLast4 ?? "****"} has
					been added but requires verification before use.
				</p>
				<div css={nextSteps}>
					<h4>Next steps:</h4>
					<ul>
						<li>• Two small test deposits will be made within 1-2 business days</li>
						<li>• Once verified, you can use this account for payments</li>
					</ul>
				</div>
			</div>
		</Modal>
	)
}

const container = css`
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 2rem;

	> span {
		background-color: #10b981;
		padding: 1rem;
		border-radius: 2rem;
		width: 3rem;
		height: 3rem;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	h3 {
		color: #111827;
		text-align: center;
		font-size: 1.5rem;
		font-weight: 700;
	}

	h4 {
		color: #1d4ed8;
		font-size: 1rem;
		margin-bottom: 0.625rem;
		font-weight: 600;
	}

	p {
		color: #111827;
		text-align: center;
		font-size: 1rem;
		font-weight: 400;
		margin: 1rem 0 2rem 0;
	}
`

const nextSteps = css`
	border: 1px solid #bfdbfe;
	background: #eff6ff;
	padding: 1rem;
	width: 100%;
	border-radius: 0.5rem;

	> p {
		color: #1d4ed8;
		font-size: 1rem;
		font-weight: 600;
	}

	ul li {
		color: #1d4ed8;
		font-size: 0.875rem;
		font-weight: 400;
	}
`
